export default __webpack_public_path__ + "static/media/bg-smd.3d411727.jpg";